import { useContext } from 'react';
import { View, Text } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import { GuideContext, GuideProgressContext } from './GuideProvider';
import { GUIDES_ENABLED } from '@/config/guides';
import Toggle from '@/components/General/inputs/Toggle';

export default function GuidePreferences({ testID = 'guides-auto-setting' }) {
    const guide = useContext(GuideContext);
    const progress = useContext(GuideProgressContext);
    if (!GUIDES_ENABLED || !guide?.accountID) return null;
    return <View style={styles.row}>
        <View style={styles.copy}>
            <Text style={styles.title}>Show first-visit guides</Text>
            <Text style={styles.body}>Automatically explain features you haven’t viewed or skipped. Manual replay stays available.</Text>
            {progress?.isError && <Text style={styles.body}>Guide preferences are temporarily unavailable.</Text>}
        </View>
        <Toggle testID={testID} accessibilityLabel="Show first-visit guides" value={progress?.state?.autoGuidesEnabled !== false} disabled={!progress?.state} onValueChange={guide.toggleAutomatic} />
    </View>;
}

const styles = StyleSheet.create(({ colors, fonts, typography, spacing }) => ({
    row: { flexDirection: 'row', alignItems: 'center', gap: spacing.md, padding: spacing.md },
    copy: { flex: 1, gap: spacing.xs },
    title: { color: colors.text, fontFamily: fonts.bold, fontSize: typography.body },
    body: { color: colors.textSecondary, fontFamily: fonts.body, fontSize: typography.caption, lineHeight: 20 },
}));
